// src/App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Signup from "./pages/Signup";
import Login from "./pages/Login";
// import Main from "./pages/Main";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
// import InstancePage from "./pages/InstancePage";
// import ChatbotWithSettings from "./pages/ChatbotWithSettings";
// import ChatbotsList from "./pages/ChatbotList";
// import Docs from "./pages/Docs";
import BlankLayout from "./components/layouts/BlankLayout";
import Layout from "./components/layouts/Layout";
import { useEffect } from "react";
import Dashboard from "./pages/Dashboard";
import ForgetPassword from "./pages/ForgetPassword";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import WhatsappBusiness from "./pages/WhatsappBusiness";
import Templates from "./pages/Templates";
import CreateTemplate from "./pages/CreateTemplate";
import Campaigns from "./pages/Campaigns";
import FlowBuilder from "./pages/FlowBuilder";
import FlowList from "./pages/FlowList";
import LiveChats from "./pages/LiveChats";
import ContactLists from "./pages/ContactLists";
import DownloadCenter from "./pages/DownloadCenter";
import BusinessDetails from "./pages/BusinessDetails";
import { LiveChatProvider } from "./contexts/LiveChatContext";
import SubscriptionGate from "./components/SubscriptionGate";

function App() {
  useEffect(() => {
    if (window.location.pathname === "/") {
      window.location.replace("/login");
    }
  }, []);

  return (
    <Router>
      <Routes>
        {/* Wrap login with BlankLayout */}
        <Route
          path="/login"
          element={
            <BlankLayout>
              <Login />
            </BlankLayout>
          }
        />

        <Route
          path="/forget-password"
          element={
            <BlankLayout>
              <ForgetPassword />
            </BlankLayout>
          }
        />

        <Route
          path="/signup"
          element={
            <BlankLayout>
              <Signup />
            </BlankLayout>
          }
        />

        <Route
          path="/business-details"
          element={
            <BlankLayout>
              <BusinessDetails />
            </BlankLayout>
          }
        />

        <Route
          path="/dashboard"
          element={
            <Layout>
              <Dashboard />
            </Layout>
          }
        />

        <Route
          path="/waba"
          element={
            <Layout>
              <WhatsappBusiness />
            </Layout>
          }
        />
        <Route
          path="/templates"
          element={
            <Layout>
              <Templates />
            </Layout>
          }
        />
        <Route
          path="/templates/create"
          element={
            <Layout>
              <CreateTemplate />
            </Layout>
          }
        />
        <Route
          path="/broadcast"
          element={
            <Layout>
              <SubscriptionGate>
                <Campaigns />
              </SubscriptionGate>
            </Layout>
          }
        />
        <Route
          path="/campaigns"
          element={
            <Layout>
              
                <Campaigns />
             
            </Layout>
          }
        />
        <Route
          path="/flow-builder"
          element={
            <Layout>
             
                <FlowBuilder />
             
            </Layout>
          }
        />

        <Route
          path="/flows/builder/:flowId"
          element={
            <Layout>
              <SubscriptionGate>
                <FlowBuilder />
              </SubscriptionGate>
            </Layout>
          }
        />

        <Route
          path="/flows/builder"
          element={
            <Layout>
             
                <FlowBuilder />
            
            </Layout>
          }
        />

        <Route
          path="/flow-list"
          element={
            <Layout>
              <SubscriptionGate>
                <FlowList />
              </SubscriptionGate>
            </Layout>
          }
        />

        <Route
          path="/flows"
          element={
            <Layout>
             
                <FlowList />
            
            </Layout>
          }
        />

        <Route
          path="/profile"
          element={
            <Layout>
              <Profile />
            </Layout>
          }
        />

        <Route
          path="/settings"
          element={
            <Layout>
              <Settings />
            </Layout>
          }
        />

        <Route
          path="/live-chats"
          element={
            <Layout>
              <LiveChats />
            </Layout>
          }
        />

        <Route
          path="/contact-lists"
          element={
            <Layout>
              <ContactLists />
            </Layout>
          }
        />

        <Route
          path="/download-center"
          element={
            <Layout>
              <DownloadCenter />
            </Layout>
          }
        />
      </Routes>

      {/* Add ToastContainer here - this is what was missing! */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        style={{ zIndex: 9999 }}
      />
    </Router>
  );
}

export default App;
